export function systemAccordion() {
  const $benefits = $('.system-components-accordion');
  if (!$benefits || $benefits.length === 0) return;

  const $head = $benefits.find('.system-components-accordion-head');
  const $body = $benefits.find('.system-components-accordion-body');

  $head.on('click', (e) => {
    const $t = $(e.currentTarget);
    if ($t.is('.active')) {
      $t.removeClass('active');
      $t.next().slideUp(300);
    } else {
      $head.removeClass('active');
      $body.slideUp(300);
      $t.addClass('active');
      $t.next().slideDown(300);
    }
  });
}
